import React from 'react';

import Helmet from './Helmet';

const Title = 'Microsoft Entra ID Integration | Canny';
const Description =
  'Use Canny’s Microsoft Entra ID Integration to collect feedback internally from employees.';
const Image = 'https://canny.io/images/canny-social.png';

const MicrosoftEntraIDLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/integrations/microsoft-entra-id' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};
export default MicrosoftEntraIDLandingHelmet;
